import { MuiIconButton } from "@dealer-center/core-components";
import { backgroundColor } from "../const";

export const PendoButton = () => (
  <MuiIconButton
    aria-label="show notifications"
    color="inherit"
    id="notification-area"
    size="large"
    sx={{
      "&:hover": {
        backgroundColor,
        color: "white",
        transform: "scale(1.1)",
        transition: "transform 0.2s",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
        borderRadius: "50%"
      },
      position: "fixed",
      right: 24,
      bottom: 6,
      backgroundColor,
      minWidth: 48,
      height: 48,
      fontWeight: 500,
      fontSize: 35
    }}
  >
    ?
  </MuiIconButton>
);
